import "../../../css/DesignSystem/Inputs/SearchField.css";
import { ReactComponent as TooltipIcon } from "../../../assets/icons/information.svg";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search icon.svg";
import Tooltip from "../Tooltip/Tooltip";

const SearchField = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Search",
  error = false,
  helperText,
  required = false,
  disabled = false,
  icon,
  OnSearch,
  tooltip,
}) => {
  const inputId = id || `search-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && OnSearch) {
      e.preventDefault();
      OnSearch();
    }
  };

  return (
    <div className={`ds-portal-input-field ${error ? "ds-portal-input-field--error" : ""}`}>
      {label && (
        
        <label
          className="ds-portal-input-label FP_Content text-black"
          htmlFor={inputId}
        >
        <div className="row gap-xs align-center">
          {label}
          {tooltip && (
            <Tooltip content={tooltip} position="left">
              
              <TooltipIcon height={10} width={10}/>
            </Tooltip>
          )}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
          </div>
          </label>
      )}
      <div className="ds-portal-input-wrapper ds-portal-input-wrapper--search">
        <input
          id={inputId}
          className="ds-portal-input FP_Content"
          style={{ border: 0, borderRadius: 0, boxShadow: "none", outline: "none" }}
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onKeyPress={handleKeyPress}
        />
        <span
          className="ds-portal-input-icon"
          onClick={OnSearch}
          style={{ cursor: "pointer" }}
        >
          <SearchIcon />
        </span>
      </div>
      {/* {helperText && (
        <div
          className={`ds-portal-input-helper ${error ? "ds-portal-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default SearchField;
